import { Col, Row } from 'react-bootstrap'
import { FormattedMessage, useIntl } from 'react-intl'

import { Heading, ProgressBar } from 'Components/_theme'

import { StepperHeaderProps } from './Stepper.types'

export const StepperHeader = (props: StepperHeaderProps) => {
  const { step, headingLabel, subHeadingLabel, progress } = props
  const intl = useIntl()

  return (
    <>
      <Row className="pt-6">
        <Col>
          <Heading as={4} size={1}>
            {intl.formatMessage(
              {
                id: 'ProgressHeader_title',
              },
              {
                step,
                title: intl.formatMessage({
                  id: headingLabel,
                }),
              },
            )}
          </Heading>
        </Col>
      </Row>

      <Row className="Stepper-sub_header mt-2">
        <Col>
          <span>
            {subHeadingLabel && <FormattedMessage id={subHeadingLabel} />}
          </span>
        </Col>
      </Row>

      <Row>
        <Col>
          <ProgressBar className="mx-n6" value={progress ?? 0} />
        </Col>
      </Row>
    </>
  )
}
